/********************************************************
 * Override these file with customer implementation to  *
 * customize vuetify themes                             *
 *******************************************************/

const themes = Object.freeze({
  themes: {
    light: {
      primary_font_color: '#FFFFFF',
      secondary_font_color: '#111E43',

      primary: {
        base: '#4173FF', //
        lighten1: '#414B69',//
        lighten2: '#678FFF',//
        lighten3: '#8DABFF',//
        lighten4: '#B3C7FF',//
        lighten5: '#D9E3FF',//
        darken1: '#325EBF',//
        darken2: '#213E7F'//
      },
      hover: {
        base: '#ECF1FF'
      },
      secondary: {
        base: '#111E43',//
        lighten1: '#414B69',//
        lighten2: '#70788E',//
        lighten3: '#A0A5B4',//
        lighten4: '#CfD2D9',//
        lighten5: '#F3F3F5'//
      },

      info: '#4173FF',
      accent: '#4173FF',

      success: {
        base: '#009C66', //
        lighten1: '#66C3A3', //
        lighten2: '#CCEBE0', //
      },

      error: {
        base: '#EB573D', //
        lighten1: '#F3998A', //
        lighten2: '#FBDDD8', //
      },
      
      warning: {
        base: '#FFBB00', //
        lighten1: '#FFD666',//
        lighten2: '#FFF1CC',//
        lighten3: '#FFFFE6'
      },

      warning_orange: {
        base: '#FF6F00'
      },

      border: {
        base: '#E0E0E0',
        lighten1: '#E3E5EE',
        lighten2: '#E8E9ED',
        darken1: '#BDBDBD',
        darken2: '#a9a9a9',
        darken3: '#91939b'
      },

      default: {
        base: '#CFD2D9',
        lighten1: '#E0E0E0',
        lighten2: '#EDF1F4',
        lighten3: '#FAFAFA',
        darken2: '#A0A5B4',
        darken3: '#757575',
        darken4: '#2f2f2f'
      },

      background: {
        base: '#FAFAFA'
      },
      //specific
      window: '#FFFFFF',
      work_card: '#FFFFFF',
      header: '#111E43',
      sidebar_icon: '#5F6368'
    },
    dark: {
      primary: '#BBDEFB',
      secondary: '#b0bec5',
      accent: '#8c9eff',
      error: '#b71c1c',
      header: '#101010',
      background: '#202020',
      window: '#303030',
      work_card: '#303030',
      text_content: '#FFFFFF',
      border0: '#616161',
      border1: '#757575',
      border2: '#BDBDBD',
      hover1: '#424242',
    },
  },
  options: {
    customProperties: true,
  },
})

export default themes;